import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { ContentfulService } from '../../services/contentful.service';
import { CommonModule } from '@angular/common';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { environment } from '../../../environments/environment';
import { NzCardModule } from 'ng-zorro-antd/card';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import { AuthService } from '../../services/auth.service';
import { GtmService } from '../../services/gtm.service';

@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [
    CommonModule,
    NzFlexModule,
    NzTypographyModule,
    NzButtonModule,
    NzDividerModule,
    NzIconModule,
    NzImageModule,
    NzFormModule,
    NzInputModule,
    NzSpaceModule,
    NzGridModule,
    NzLayoutModule,
    NzCardModule,
    NzAnchorModule,
  ],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
})
export class LandingPageComponent implements OnInit, AfterViewChecked {
  load = false;
  contentPage: any;
  private arrayPromise = new Array();
  isPhonePortrait = false;

  constructor(
    private contentfulService: ContentfulService,
    private responsive: BreakpointObserver,
    private auth: AuthService,
    private gtmService: GtmService
  ) {}

ngOnInit(): void {
  const landingPageId = environment.contentful.landindPageId;
  this.contentfulService.getEntryIds(landingPageId).subscribe((blocks: any) => {
    this.contentPage = blocks;
    for (const key in blocks) {
      const sysId = blocks[key]?.sys?.id;
      if (sysId) {
        const elementPromise = this.contentfulService.getEntry(sysId);
        this.arrayPromise.push(elementPromise);
        elementPromise.subscribe((value) => {
        this.contentPage[key] = { fields: value.fields ?? value };
        });
      }
    }
    Promise.all(this.arrayPromise).then(() => {
      this.parsevalue(this.contentPage);
      Promise.all(this.arrayPromise).then(() => {
        this.load = true;
        console.debug(this.contentPage);
      });
    });
  });

  this.responsive.observe(Breakpoints.HandsetPortrait).subscribe((result) => {
    this.isPhonePortrait = false;
      if (result.matches) {
        this.isPhonePortrait = true;
      }
  });
  this.auth.isAuthenticatedSubject.next(false);
}


  ngAfterViewChecked() {
    const collection = document.getElementsByClassName('ant-anchor-ink');
    for (var i = 0; i < collection.length; i++) {
      collection[i].remove();
    }
  }

  parsevalue(obj: any): void {
    for (let field in obj) {
      if (!Array.isArray(obj[field]) && typeof obj[field] === 'object') {
        this.parsevalue(obj[field].fields);
      } else if (obj[field] instanceof Array) {
        for (let i = 0; i < obj[field].length; i++) {
          let element: any = obj[field][i];
          if (element['sys'] && element['sys']['linkType'] && element['sys']['linkType'] === 'Entry') {
          let elementPromise = this.contentfulService.getEntry(element['sys']['id']);            
          this.arrayPromise.push(elementPromise);
            elementPromise.subscribe((value) => {
              obj[field][i] = value;
            });
          }
        }
      }
    }
  }

  _returnHtmlFromRichText(richText: any) {
    return documentToHtmlString(richText);
  }

  onSubscribeClick(fullTitle: string, uri: string) {
    const type = fullTitle.split(' ').pop();
    this.gtmService.pushSubscribeClickEvent(type);
    this.btnRedirect(uri);
  }

  btnRedirect(uri: string) {
    window.location.href = uri;
  }
}
